/**
 *
 */
const setupSiteNotifications = () =>
{
	const notification = document.querySelector( '#site-notification' );
	const closeBtn     = document.querySelector( '#site-notification .controls .close' );

	if (!(closeBtn instanceof HTMLElement)) {
		return;
	}

	closeBtn.addEventListener( 'click', e =>
	{
		e.preventDefault();

		notification.classList.add( 'visually-hidden' );
	} );

};


/**
 *
 */
export default setupSiteNotifications;